import domReady from './inc/dom-ready.js';
import { assignRotateVars, randomNum } from './inc/helpers.js';
import { boilerplateNavMain } from './inc/nav-main-vcc.js';
import elmntIO from './inc/elmnt-io.js';
import { nnGsapParallax, nnGsapVpProgress } from './inc/nn-gsap-effects.js';
import { headerColor, stickyHeader } from './site-header.js';
import { headerAlertBar } from './alert-bar.js';
import { siteFooterInstaScrollIn } from './site-footer.js';
import { heroFullScreen } from './hero-full-screen.js';
import { heroSpacey } from './hero-spacey.js';
import { heroInspo } from './hero-inspo.js';
import { setupBaseTextCharAnimation } from './text-animation.js';
import { slidersInit } from './sliders.js';
import { mapSlider } from './map-slider.js';
import { itineraryGridComp } from './itinerary-grid.js';
import { tableOfContents } from './table-of-contents.js';
import { archive } from './archive.js';
import { trackCursorInAreaAll } from './cursor-tracking.js';
import { mtFrontEndBuilder } from './vcc-mindtrip.js';
import { accordions } from './inc/accordion.js';
import { globalPopup } from './popup.js';



domReady( function () {
    //do something after DOM loads.

    // ===== set header height =====
    const $siteHeader = document.querySelector('.site-header');
    if ($siteHeader) {
        document.body.style.setProperty('--header-height', $siteHeader.offsetHeight + 'px');

        window.addEventListener('resize', () => {
            document.body.style.setProperty('--header-height', $siteHeader.offsetHeight + 'px');
        });
    }

    // ===== priority functions =====
    headerColor();
    stickyHeader({
        headerSm: false,
        headerHide: true,
    });
    headerAlertBar();
    boilerplateNavMain({
        mobileBreakpoint: 1400,
        // megaMenuTransitionMs: 1000,
    });

    // ===== base text animation setup =====
    setupBaseTextCharAnimation();

    // ===== classes & vars =====
    // do not set slider elements classes here, set them in the sliders.js file
    const arrRotateVarSelectors = [
        '.component--ftr-blog-entries .blog-card',
        '.component--season-itineraries .itinerary-card',
        '.component--slider-itineraries .itinerary-card',
        '.component--slider-blog .blog-slide-card',
        '.component--link-card-ctas .link-card',
        '.archive-link-cards .link-card',
        '.archive-item__img-wrap',
        // '.media-content__img',
    ];
    assignRotateVars(arrRotateVarSelectors);

    
    // ===== default elmntIOs =====
    const $elmntIos = document.querySelectorAll('[data-io]:not(.ignore-io)');
    $elmntIos.forEach($el => elmntIO($el));


    // ===== more =====
    siteFooterInstaScrollIn();
    window.addEventListener('servd.dynamicloaded', siteFooterInstaScrollIn);
    heroFullScreen();
    heroSpacey();
    heroInspo();
    slidersInit();
    mapSlider();
    itineraryGridComp();
    tableOfContents();
    archive();
    nnGsapParallax();
    trackCursorInAreaAll();
    mtFrontEndBuilder();
    accordions();
    globalPopup();


    // ===== small tasks =====
    const $eventItems = document.querySelectorAll('.event-item');
    $eventItems?.forEach($item => {
        let rotateDeg = randomNum(3, 6);
        // randomly set negative value
        if (Math.random() > 0.5) {
            rotateDeg = -rotateDeg;
        }
        $item.style.setProperty('--rotate-deg', `${rotateDeg}deg`);
    });


    // ===== vp progress =====
    const $compsMtFeBuilder = document.querySelectorAll('.component--mt-fe-builder, .hero-inspo__beat--3');
    $compsMtFeBuilder?.forEach($comp => {
        nnGsapVpProgress($comp, {
            startFromBottom: '50%',
        });
    });

    // ===== initial js has loaded =====
    document.body.classList.add('js-loaded');
} );